import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';

// Update profile picture
export async function POST(request: NextRequest) {
  try {
    const body = await request.json();
    const { email, profilePicture } = body;

    if (!email) {
      return NextResponse.json(
        { error: 'Email is required' },
        { status: 400 }
      );
    }

    // Find user
    const user = await db.users.findByEmail(email);
    if (!user) {
      return NextResponse.json(
        { error: 'User not found' },
        { status: 404 }
      );
    }

    // Update profile picture in database
    await db.users.updateProfilePicture(user.id, profilePicture);

    return NextResponse.json({
      success: true,
      message: 'Profile picture updated successfully'
    });

  } catch (error) {
    console.error('Profile picture update error:', error);
    return NextResponse.json(
      { error: 'Failed to update profile picture' },
      { status: 500 }
    );
  }
}

// Get profile picture
export async function GET(request: NextRequest) {
  try {
    const { searchParams } = new URL(request.url);
    const email = searchParams.get('email');

    if (!email) {
      return NextResponse.json(
        { error: 'Email is required' },
        { status: 400 }
      );
    }

    // Find user
    const user = await db.users.findByEmail(email);
    if (!user) {
      return NextResponse.json(
        { error: 'User not found' },
        { status: 404 }
      );
    }

    return NextResponse.json({
      profilePicture: user.profilePicture || null
    });

  } catch (error) {
    console.error('Get profile picture error:', error);
    return NextResponse.json(
      { error: 'Failed to get profile picture' },
      { status: 500 }
    );
  }
}

// Delete profile picture
export async function DELETE(request: NextRequest) {
  try {
    const { searchParams } = new URL(request.url);
    const email = searchParams.get('email');

    if (!email) {
      return NextResponse.json(
        { error: 'Email is required' },
        { status: 400 }
      );
    }

    // Find user
    const user = await db.users.findByEmail(email);
    if (!user) {
      return NextResponse.json(
        { error: 'User not found' },
        { status: 404 }
      );
    }

    // Remove profile picture
    await db.users.updateProfilePicture(user.id, null);

    return NextResponse.json({
      success: true,
      message: 'Profile picture removed successfully'
    });

  } catch (error) {
    console.error('Delete profile picture error:', error);
    return NextResponse.json(
      { error: 'Failed to delete profile picture' },
      { status: 500 }
    );
  }
}
